import { Outlet } from "react-router";
import { QuizContentProvider } from "../../providers/QuizContentProvider/Provider";

export const QuizLayout = () => {
  return (
    <QuizContentProvider>
      <Outlet />
    </QuizContentProvider>
  );
}